import { ErrorTypes } from '@/services/api/errorCodes';
import { PropertyKeyModel } from '@/models/property-keys'
import {
    REMOVE_PROPERTY_KEYS,
    SET_PROPERTY_KEYS,
    SET_PROPERTY_KEYS_ERROR_CODE,
    SET_PROPERTY_KEYS_LOADING_STATE,
    SET_PROPERTY_SCHEDULED_KEYS_DATE,
    SET_SCHEDULED_PROPERTY_KEYS_LOADING_STATE,
} from '@/redux/ActionTypes/property-keys'

export interface PropertyKeysState {
    propertyKeys: PropertyKeyModel[];
    isKeysDataLoading: boolean;
    isScheduledKeysLoading: boolean;
    error: ErrorTypes | null;
    scheduledKeysDate: Date | null;
}

const PropertyKeysInitialState: PropertyKeysState = {
    propertyKeys: [],
    isKeysDataLoading: true,
    isScheduledKeysLoading: true,
    error: null,
    scheduledKeysDate: null,
};

interface Action {
    type: string;
    propertyKeyId: string;
    propertyKeys: PropertyKeyModel[];
    isLoading: boolean;
    error: ErrorTypes;
    scheduledKeysDate: Date | null;
}

export default (state = PropertyKeysInitialState, action: Action): PropertyKeysState => {
    switch (action.type) {
        case SET_PROPERTY_KEYS: {
            return { ...state, propertyKeys: action.propertyKeys };
        }
        case REMOVE_PROPERTY_KEYS: {
            return { ...state, propertyKeys: [] };
        }
        case SET_PROPERTY_KEYS_LOADING_STATE: {
            return { ...state, isKeysDataLoading: action.isLoading };
        }
        case SET_SCHEDULED_PROPERTY_KEYS_LOADING_STATE: {
            return { ...state, isScheduledKeysLoading: action.isLoading };
        }
        case SET_PROPERTY_KEYS_ERROR_CODE: {
            return { ...state, error: action.error };
        }
        case SET_PROPERTY_SCHEDULED_KEYS_DATE: {
            return { ...state, scheduledKeysDate: action.scheduledKeysDate };
        }
        default:
            return state;
    }
};
